import $ from 'jquery';
//import starRating from 'jquery.star-rating-svg';
//import { styles } from 'css-star-rating';


$(document).ready(function () {

    //Click event to scroll to top
    $('.scrollToTop-wrapper').click(function () {
        $('html, body').animate({scrollTop: 0}, 900);
    });

    $('.rating-stars').change(function () {
        console.log('New star rating: ' + this.value);
    });

    //DISABLE ENTER ON SEARCH FORM
    $('#kalamaki-search-form').on('keyup keypress', function (e) {
        var keyCode = e.keyCode || e.which;
        if (keyCode === 13) {
            e.preventDefault();
            return false;
        }
    });

    //Homepage items navigation
    $('.homepage-item').click(function () {
        var url = $(this).attr('url');
        window.location.href = url;
    });
    
    
    // Remove empty fields from GET forms
    // Change 'form' to class or ID of your specific form
    $("form").submit(function() {
            $(this).find(":input").filter(function(){ return !this.value; }).attr("disabled", "disabled");
            return true; // ensure form still submits
    });

    // Un-disable form fields when page loads, in case they click back after submission
    $( "form" ).find( ":input" ).prop( "disabled", false );
    
});

$(window).load(function () {
    //sticky searchbox
    var searchBoxContainer = $('.search-box-wrapper');
    if (searchBoxContainer.length > 0) {
        var searchBox = $(searchBoxContainer).find('.search-box');

        var timeOutTimer = null;
        var breakpoint = 835;
        var spaceAboveSearchBox = 25;
        var searchBoxHeight,
            contentHeight,
            windowHeight,
            searchBoxOffsetTop,
            deltaMax;

        var calcValues = function () {
            windowHeight = $(window).innerHeight();
            searchBoxHeight = $(searchBox).innerHeight();
            contentHeight = $('.archive-content').innerHeight();
            searchBoxOffsetTop = $(searchBox).offset().top;
            deltaMax = contentHeight - searchBoxHeight;
        };

        calcValues();
        var searchBoxScrollHandler = function () {
            var windowScrollPosition = $(window).scrollTop();
            if (searchBoxHeight > contentHeight || searchBoxHeight >= windowHeight) {
                return false;
            }
            if ($(window).width() >= breakpoint && windowScrollPosition > searchBoxOffsetTop) {
                var delta = windowScrollPosition - searchBoxOffsetTop + spaceAboveSearchBox;
                if (delta >= deltaMax) {
                    delta = deltaMax;
                }
                $(searchBox).css({
                    transform: 'translate3d(0,' + delta + 'px, 0)',
                });
            } else {
                $(searchBox).css({
                    transform: 'translate3d(0, 0, 0)',
                });
            }
        };

        $(window).scroll(function () {
            if (timeOutTimer) {
                clearTimeout(timeOutTimer);   // clear any previous pending timer
            }
            timeOutTimer = setTimeout(searchBoxScrollHandler, 20);   // set new timer
        });

        // Toggle Search Form for Mobile
        var searchFormWrapper = $('.search-form-wrapper');
        var formHeight = $(searchFormWrapper).find('form').outerHeight();
        var formToggleButton = $(searchBoxContainer).find('.search-form-toggler');

        var calcFormHeight = function () {
            formHeight = $(searchFormWrapper).find('form').outerHeight();
        };
        var initSearchForm = function () {
            if ($(searchBoxContainer).hasClass('form-hidden')) {
                return true;
            }
            $(searchFormWrapper).css('height', 0);
            $(searchBoxContainer).addClass('form-hidden');
        };

        var toggleSearchForm = function () {
            if ($(searchBoxContainer).hasClass('form-hidden')) {
                $(searchBoxContainer).removeClass('form-hidden');
                $(searchFormWrapper).css('height', formHeight);
            } else {
                $(searchBoxContainer).addClass('form-hidden');
                $(searchFormWrapper).css('height', 0);
            }
        };
        calcFormHeight();
        initSearchForm();

        $(formToggleButton).on('click', function () {
            toggleSearchForm();
        });

        // Window resize
        $(window).resize(function () {
            if (timeOutTimer) {
                clearTimeout(timeOutTimer);   // clear any previous pending timer
            }
            timeOutTimer = setTimeout(function () {
                calcValues();
                calcFormHeight();
                searchBoxScrollHandler();
            }, 20);
        });
    }
});


// WEBPACK FOOTER //
// ./assets/js/src/modules/general.js